import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { Hero } from './components/Hero';
import { Vision } from './components/Vision';
import { Mission } from './components/Mission';
import { Courses } from './components/Courses';
import { ContactForm } from './components/ContactForm';
import { LanguageToggle } from './components/LanguageToggle';
import './i18n/config';
export function App() {
  return <HelmetProvider data-id="element-0">
      <Helmet data-id="element-1">
        <title data-id="element-2">
          Zoe Institute - English, Programming & Professional Courses
        </title>
        <meta name="description" content="Zoe Institute offers comprehensive courses in English language, IELTS preparation, programming, computer science, and professional development. Learn from expert instructors with personalized attention." data-id="element-3" />
        <meta name="keywords" content="English courses, IELTS preparation, programming courses, computer courses, French classes, Arabic language, school education, university courses, AI ML, Python, Java" data-id="element-4" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" data-id="element-5" />
        <meta charSet="utf-8" data-id="element-6" />
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" data-id="element-7" />
        <meta property="og:title" content="Zoe Institute - English, Programming & Professional Courses" data-id="element-8" />
        <meta property="og:description" content="Transform your future with expert-led courses in English, programming, and professional skills at Zoe Institute." data-id="element-9" />
        <meta property="og:image" content="https://uploadthingy.s3.us-west-1.amazonaws.com/vFiyUZ5U9tjaQyeYT1Y755/WhatsApp_Image_2025-10-22_at_20.06.11_%281%29.jpg" data-id="element-10" />
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" data-id="element-11" />
        <meta name="twitter:title" content="Zoe Institute - English, Programming & Professional Courses" data-id="element-12" />
        <meta name="twitter:description" content="Transform your future with expert-led courses in English, programming, and professional skills at Zoe Institute." data-id="element-13" />
        <meta name="twitter:image" content="https://uploadthingy.s3.us-west-1.amazonaws.com/vFiyUZ5U9tjaQyeYT1Y755/WhatsApp_Image_2025-10-22_at_20.06.11_%281%29.jpg" data-id="element-14" />
        <meta name="theme-color" content="#14b8a6" data-id="element-15" />
      </Helmet>
      <div className="w-full min-h-screen bg-gradient-to-b from-slate-50 to-white" data-id="element-16">
        <LanguageToggle data-id="element-17" />
        <Hero data-id="element-18" />
        <Vision data-id="element-19" />
        <Mission data-id="element-20" />
        <Courses data-id="element-21" />
        <ContactForm data-id="element-22" />
      </div>
    </HelmetProvider>;
}